import React from 'react';
import AboutUs from '../components/AboutUs';
import Team from '../components/Team';
import Testimonials from '../components/Testimonials';

const About = () => {
  return (
    <>
      <AboutUs />
      <Team />
      <Testimonials />
    </>
  );
};

export default About;

